/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  AddToBatchRequest,
  AddTouchpointVersionToBatchPathParameters,
  ChangeStatusPathParameters,
  Create3PathParameters,
  Delete1PathParameters,
  GetAll2Params,
  GetAll2PathParameters,
  GetAllBatchVersionsParams,
  GetAllBatchVersionsPathParameters,
  GetOnePathParameters,
  PagedModelTouchpointBatchDTO,
  PagedModelTouchpointVersionBatchDTO,
  RemoveTouchpointVersionFromBatchPathParameters,
  TouchpointBatchDTO,
  TouchpointBatchRequest,
  TouchpointBatchStatusRequest,
  TouchpointVersionBatchDTO,
  Update1PathParameters,
} from "../schemas";

import { customInstance } from "../../config/mutator";

export const getTouchpointBatch = () => {
  /**
 * Get a touchpoint batch

Required authority: PERM_TOUCHPOINT_READ
 */
  const getOne = ({ clientId, batchId }: GetOnePathParameters) => {
    return customInstance<TouchpointBatchDTO>({
      url: `/api/clients/${clientId}/touchpoint-batches/${batchId}`,
      method: "GET",
    });
  };
  /**
 * Update touchpoint version batch

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const update1 = (
    { clientId, batchId }: Update1PathParameters,
    touchpointBatchRequest: TouchpointBatchRequest,
  ) => {
    return customInstance<TouchpointBatchDTO>({
      url: `/api/clients/${clientId}/touchpoint-batches/${batchId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: touchpointBatchRequest,
    });
  };
  /**
 * Delete a touchpoint batch

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const delete1 = ({ clientId, batchId }: Delete1PathParameters) => {
    return customInstance<void>({
      url: `/api/clients/${clientId}/touchpoint-batches/${batchId}`,
      method: "DELETE",
    });
  };
  /**
 * Partially update a touchpoint version batch

Required authority (any of): PERM_TOUCHPOINT_WRITE, PERM_CLIENT_APPROVAL
 */
  const changeStatus = (
    { clientId, batchId }: ChangeStatusPathParameters,
    touchpointBatchStatusRequest: TouchpointBatchStatusRequest,
  ) => {
    return customInstance<TouchpointBatchDTO>({
      url: `/api/clients/${clientId}/touchpoint-batches/${batchId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: touchpointBatchStatusRequest,
    });
  };
  /**
 * Get all touchpoint batches for a client

Required authority: PERM_TOUCHPOINT_READ
 */
  const getAll2 = ({ clientId }: GetAll2PathParameters, params?: GetAll2Params) => {
    return customInstance<PagedModelTouchpointBatchDTO>({
      url: `/api/clients/${clientId}/touchpoint-batches`,
      method: "GET",
      params,
    });
  };
  /**
 * Create a touchpoint version batch

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const create3 = (
    { clientId }: Create3PathParameters,
    touchpointBatchRequest: TouchpointBatchRequest,
  ) => {
    return customInstance<TouchpointBatchDTO>({
      url: `/api/clients/${clientId}/touchpoint-batches`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: touchpointBatchRequest,
    });
  };
  /**
 * Get all touchpoint versions for a batch

Required authority: PERM_TOUCHPOINT_READ
 */
  const getAllBatchVersions = (
    { clientId, batchId }: GetAllBatchVersionsPathParameters,
    params?: GetAllBatchVersionsParams,
  ) => {
    return customInstance<PagedModelTouchpointVersionBatchDTO>({
      url: `/api/clients/${clientId}/touchpoint-batches/${batchId}/versions`,
      method: "GET",
      params,
    });
  };
  /**
 * Add touchpoint version to batch

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const addTouchpointVersionToBatch = (
    { clientId, batchId }: AddTouchpointVersionToBatchPathParameters,
    addToBatchRequest: AddToBatchRequest,
  ) => {
    return customInstance<TouchpointVersionBatchDTO>({
      url: `/api/clients/${clientId}/touchpoint-batches/${batchId}/versions`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: addToBatchRequest,
    });
  };
  /**
 * Remove touchpoint version from batch

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const removeTouchpointVersionFromBatch = ({
    clientId,
    batchId,
    versionId,
  }: RemoveTouchpointVersionFromBatchPathParameters) => {
    return customInstance<void>({
      url: `/api/clients/${clientId}/touchpoint-batches/${batchId}/versions/${versionId}`,
      method: "DELETE",
    });
  };
  return {
    getOne,
    update1,
    delete1,
    changeStatus,
    getAll2,
    create3,
    getAllBatchVersions,
    addTouchpointVersionToBatch,
    removeTouchpointVersionFromBatch,
  };
};
export type GetOneResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointBatch>["getOne"]>>
>;
export type Update1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointBatch>["update1"]>>
>;
export type Delete1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointBatch>["delete1"]>>
>;
export type ChangeStatusResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointBatch>["changeStatus"]>>
>;
export type GetAll2Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointBatch>["getAll2"]>>
>;
export type Create3Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointBatch>["create3"]>>
>;
export type GetAllBatchVersionsResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointBatch>["getAllBatchVersions"]>>
>;
export type AddTouchpointVersionToBatchResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointBatch>["addTouchpointVersionToBatch"]>>
>;
export type RemoveTouchpointVersionFromBatchResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointBatch>["removeTouchpointVersionFromBatch"]>>
>;
